/* v25: protect the editor frame only, without altering shopper navigation or app code. */
(function () {
  'use strict';
  var context = window.KMThemeContext;
  function inEditor() { return !!(context && context.isEditor()); }
  if (!inEditor()) return;
  var domains = [location.hostname];
  [context.shopUrl, context.permanentDomain].forEach(function (value) {
    if (!value) return;
    try {
      var host = new URL(value.indexOf('://') === -1 ? 'https://' + value : value).hostname;
      domains.push(host, host.replace(/^www\./, ''), 'www.' + host.replace(/^www\./, ''));
    } catch (_) {}
  });
  function owned(url) { return domains.indexOf(url.hostname) !== -1; }
  function accountOrCheckout(url) {
    // Classic /account/login templates remain editable. New accounts and checkout are separate applications.
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:checkout(?:s)?|customer_authentication|services\/login_with_shop)(?:\/|$)/i.test(url.pathname) ||
      /^(?:accounts|account)\./i.test(url.hostname);
  }
  function note(message, destination) {
    var box = document.getElementById('km-editor-navigation-note');
    if (!box) {
      box = document.createElement('aside');
      box.id = 'km-editor-navigation-note';
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;margin:auto;max-width:680px;padding:14px 18px;background:#fff;color:#221f20;border:1px solid #c4b7aa;border-radius:8px;box-shadow:0 3px 18px #0002;z-index:2147483646;font:13px/1.6 sans-serif';
      document.body.appendChild(box);
    }
    box.replaceChildren();
    var text = document.createElement('span'); text.textContent = message; box.appendChild(text);
    if (destination) {
      var link = document.createElement('a');
      link.href = destination; link.target = '_blank'; link.rel = 'noopener noreferrer';
      link.dataset.kmOutsideEditor = 'true'; link.textContent = ' 새 탭에서 확인';
      link.style.cssText = 'color:#661218;text-decoration:underline;margin-left:8px'; box.appendChild(link);
    }
    var close = document.createElement('button'); close.type = 'button'; close.textContent = '닫기';
    close.style.cssText = 'margin-left:12px;background:transparent;color:#221f20;border:0;cursor:pointer';
    close.addEventListener('click', function () { box.remove(); }); box.appendChild(close);
  }
  context.notice = note;
  document.addEventListener('click', function (event) {
    if (!inEditor() || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    // Do not interfere with Shopify's preview inspector click-to-select.
    if (window.Shopify && window.Shopify.inspectMode) return;
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a || a.dataset.kmOutsideEditor === 'true') return;
    var url; try { url = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol)) return;
    if (accountOrCheckout(url)) {
      event.preventDefault(); event.stopImmediatePropagation();
      note('계정 인증과 결제 화면은 테마 편집기 밖의 미리보기에서 확인해 주세요.', url.href);
      return;
    }
    // Retain the editor/preview host for internal links stored with the primary shop domain.
    if (owned(url) && url.origin !== location.origin && (!a.target || a.target === '_self')) {
      a.setAttribute('href', url.pathname + url.search + url.hash);
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (!inEditor() || event.defaultPrevented) return;
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var url; try { url = new URL(form.action, location.href); } catch (_) { return; }
    var kind = form.querySelector('[name="form_type"]');
    var submitter = event.submitter;
    var localize = /\/localization\/?$/.test(url.pathname) || (kind && kind.value === 'localization');
    var checkout = accountOrCheckout(url) || (submitter && submitter.name === 'checkout');
    if (!localize && !checkout) return;
    event.preventDefault(); event.stopImmediatePropagation();
    note(localize ? '편집기 안에서는 국가·언어 전환을 보내지 않습니다. 상단 Market·언어 선택으로 미리보기를 변경해 주세요.' :
      '결제는 테마 편집기 밖의 스토어 미리보기에서 확인해 주세요. 이 화면에서는 주문을 전송하지 않았습니다.');
  }, true);
})();
